import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { getStatus } from "src/app/common";
import { RequestURL, RoutesAll } from "src/app/Constants/app.constants";
import { OrderService } from "src/app/shared/services/order.service";


@Injectable({
  providedIn: 'root'
})
export class EstablishmentPageGuard implements CanActivate {
  entityId: any;
  orderId: any;
  gstinStatus: any;
  statusList = [];

  constructor(private router: Router, private orderService: OrderService, private route: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkStatusValidOrNot(route);
  }

  async checkStatusValidOrNot(route: ActivatedRouteSnapshot): Promise <boolean>{
    var isConsentPanding = false;
    this.entityId = route.queryParamMap.get('id');
    await this.getStatusList();

    for (var i = 0; i < this.statusList.length; i++) {
      if (route.queryParamMap.get('id') && (this.statusList[i] == '4' || this.statusList[i] == '3' || this.statusList[i] == '0' || this.statusList[i] == '11')) {
        isConsentPanding = true;
      }
    }
    if (!isConsentPanding) {
      this.router.navigate([RoutesAll.accessDenied]);
    }
    return true;
  }

  getStatusList() {
    getStatus.entityId = this.entityId;
    return new Promise((resolve) => {
      this.orderService.fetchStatus(getStatus, RequestURL.fetchStatus, (data: any) => {
        this.statusList = data;
        resolve("");
      });
    });
  }
}
